export default __webpack_public_path__ + "static/media/HLB.ceac7b35.ttf";